import { getPrice } from './getPrice';

/**
 * @memberof module:util
 * @function
 * @name getAIRChargeableWeight
 * @description Calculate AIR Chargeable Weight.
 * If weight unit is in LB or LBS, then convert it to KG.
 * If volume unit is in CFT, then convert it to CBM.
 *
 * @param {Object} obj - It contains weight and volume info.
 * @param {Object} obj.totalWeight - total weight of the shipment.
 * @param {Object} obj.weightUnit - unit of total weight.
 * @param {Object} obj.totalVolume - total volume of the shipment.
 * @param {Object} obj.volumeUnit - unit of total volume.
 * @returns {number}
 *
 * @example
 * console.log(getAIRChargeableWeight({ totalWeight:2350, weightUnit:"LBS", totalVolume:15, volumeUnit:"CBM" })); //2500
 */
export const getAIRChargeableWeight = ({
  totalWeight,
  weightUnit,
  totalVolume,
  volumeUnit,
}) => {
  let wtInKG;
  let volInCBM;
  if (weightUnit === 'KG') {
    wtInKG = totalWeight;
  } else {
    wtInKG = totalWeight / 2.205;
  }

  if (volumeUnit === 'CBM') {
    volInCBM = totalVolume;
  } else {
    volInCBM = totalVolume * 35.315;
  }

  const temp = getPrice(Math.max(wtInKG, volInCBM / 0.006));

  // console.log('getAIRChargeableWeight', temp);
  return temp;
};
